// Define the mapping object
const utmSourceNameToValueMap: any = {
	Google: 1,
	Facebook: 2,
	Instagram: 3,
	"Linked In": 4,
	Wetransfer: 5,
	Organic: 6,
	Others: 7,
	SEM: 8,
	Youtube: 9,
	Verizon: 10,
	Aqarmap: 11,
	"Property Finder": 12,
	OLX: 13,
	Postquare: 14,
	Taboola: 15,
	Truecaller: 16,
	"Cairo Scene": 17,
	"Scoop Empire": 18,
	"Cairo 360": 19,
	"Egyptian Streets": 20,
	Twitter: 21,
	Snapchat: 22,
	"Youm 7": 23,
	"ESKIMI Programmatic": 24,
	"Evolve Programmatic": 25,
	DV360: 26,
	Tiktok: 27,
	Shahid: 28,
	"Watch It": 29,
	VIU: 30,
	Viber: 31,
	Spotify: 32,
	Anghami: 33,
	Speakol: 34,
	wechat: 35,
	"Huawei Ads": 36,
	PMax: 37,
	GDN: 38,
	QRCode: 40,
	Meta: 41,
	EDM: 42,
	Whatsapp: 43,
	Influencer: 44,
}

const utmMediumNameToValueMap: any = {
	GDN: 1,
	"Google Search": 2,
	Youtube: 3,
	Programmatic: 4,
	"Lead Ad": 5,
	Conversion: 6,
	Organic: 7,
	"Online Sheet": 8,
	// Others: 9,
	"Native Ad": 10,
	MastHead: 11,
	"Digital PR": 12,
	"Rich Media": 13,
	Sponsorship: 14,
	QRCode: 15,
	Meta: 16,
	EDM: 17,
	Whatsapp: 18,
	Others: 19,
}

const projectSlugOrIDCode: any = {
	// tested
	"core-apartments": "3ad8201a-bbba-ee11-a568-000d3abdf95c",
	"1": "3ad8201a-bbba-ee11-a568-000d3abdf95c",

	"club-yard": "dd6753c1-4d4a-ed11-bba1-6045bd8c5a56",
	"3": "dd6753c1-4d4a-ed11-bba1-6045bd8c5a56",

	// tested
	"green-valley": "664e80a0-baba-ee11-a568-000d3abdf95c",
	"4": "664e80a0-baba-ee11-a568-000d3abdf95c",

	"hillside": "df4c8410-aebb-eb11-8236-000d3a2aa36e",
	"5": "df4c8410-aebb-eb11-8236-000d3a2aa36e",

	"hillside-bliss": "e14c8410-aebb-eb11-8236-000d3a2aa3e6",
	"6": "df4c8410-aebb-eb11-8236-000d3a2aa36e",

	// tested
	"mid-yard": "ecb81f28-baba-ee11-a568-000d3abdf95c",
	"7": "ecb81f28-baba-ee11-a568-000d3abdf95c",

	"spring-valley": "b5915c4c-d1a4-ed11-bb31-6045bd8c528e",
	"8": "b5915c4c-d1a4-ed11-bb31-6045bd8c528e",
	
	// tested
	"tulwa": "8a2dfbf5-d747-e911-a975-000d3a209848",
	"9": "8a2dfbf5-d747-e911-a975-000d3a209848",

	"whyt": "9ba2338a-65f9-e811-a971-000d3a209848",
	"10": "9ba2338a-65f9-e811-a971-000d3a209848",

	"parkside": "416e5db4-4b2f-f011-8c4e-7c1e5283a6e4",
	"11": "416e5db4-4b2f-f011-8c4e-7c1e5283a6e4",
};

// Function to get the value by name
export const getUtmSourceByName = (name: any) => {
	return utmSourceNameToValueMap[name] || null // Return null if name doesn't exist
}

export const getUtmMediumByName = (name: any) => {
	return utmMediumNameToValueMap[name] || utmMediumNameToValueMap["Others"] // Return null if name doesn't exist
}

export const getProjectCodeBySlugOrID = (slugOrId: any) => {
	return projectSlugOrIDCode[slugOrId] || ""
}
